<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      @click="handleOpen()"
      class="cursor-pointer fixed top-4 right-4 z-[9999] max-w-sm w-full bg-white dark:bg-[#2a3042] shadow-2xl rounded-2xl pointer-events-auto border border-gray-100 dark:border-gray-800 overflow-hidden group"
    >
      <div class="p-5">
        <div class="flex items-start gap-4">
          <div
            class="flex-shrink-0 h-12 w-12 rounded-2xl bg-primary-50 dark:bg-primary-900/30 flex items-center justify-center transition-transform group-hover:scale-110"
          >
            <i
              class="mdi text-2xl text-primary-600 dark:text-primary-400"
              :class="iconClass"
            ></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex justify-between items-start">
              <p
                class="text-sm font-bold text-primary-900 dark:text-white mb-1"
              >
                {{ title }}
              </p>
              <button
                @click.stop="close"
                class="ml-2 flex-shrink-0 bg-transparent cursor-pointer rounded-full inline-flex text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors border-none p-1"
              >
                <span class="sr-only">Chiudi</span>
                <i class="mdi mdi-close text-lg"></i>
              </button>
            </div>
            <p
              class="text-[13px] leading-relaxed text-gray-500 dark:text-white/80 mb-0"
            >
              {{ message }}
            </p>
          </div>
        </div>
      </div>
      <!-- Progress bar -->
      <div
        v-if="show"
        class="h-1 bg-primary-600 transition-all duration-[4000ms] ease-linear w-0 animate-progress"
      ></div>
    </div>
  </transition>
</template>

<script>
import { routesEnums } from "@/helpers/enums";
import { mapActions } from "vuex";
import { MODULES } from "@/store/modules-enum";
import { NOTIFICATIONS_ACTIONS } from "@/store/notifications/actions-enum";

export default {
  name: "NotificationToast",
  data() {
    return {
      show: false,
      title: "",
      message: "",
      actionType: null,
      notificationData: null,
      timer: null,
    };
  },
  computed: {
    iconClass() {
      const type = String(
        this.actionType || this.notificationData?.type || ""
      );
      switch (type) {
        case "2":
          return "mdi-tag-outline"; // Promo
        case "3":
          return "mdi-clock-alert-outline"; // Scadenza
        default:
          return "mdi-bell-outline"; // Default
      }
    },
  },
  methods: {
    ...mapActions(MODULES.NOTIFICATIONS, [
      NOTIFICATIONS_ACTIONS.REMOVE_NOTIFICATIONS_BY_TYPE,
    ]),
    display(payload, duration = 5000) {
      this.title = payload.title;
      this.message = payload.body || payload.message;
      this.actionType = payload.type;
      this.notificationData = payload.data || {};
      this.show = true;

      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.close();
      }, duration);
    },
    close() {
      this.show = false;
      if (this.timer) clearTimeout(this.timer);
    },
    handleOpen() {
      const type = String(
        this.actionType || this.notificationData?.type || ""
      );
      const url = this.notificationData?.url || null;

      if (type && !url) {
        switch (type) {
          case "3":
            this.$router
              .push("/bandi-in-scadenza")
              .catch((err) => {
                if (err.name !== "NavigationDuplicated") throw err;
              });
            break;
          case "2":
            const act = this.notificationData?.act;
            if (act) {
              this.$router
                .push({
                  name: routesEnums.PROFILE,
                  params: { promoCode: act },
                })
                .catch((err) => {
                  if (err.name !== "NavigationDuplicated") throw err;
                });
              this.$root.$emit("promo-activated", act);
            }
            break;
          default:
            break;
        }
      } else if (url) {
        window.open(url, "_blank", "noopener");
      }
      this.close();
    },
  },
};
</script>

<style scoped>
@keyframes progress {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
.animate-progress {
  animation: progress 4s linear forwards;
}
</style>
